import type { TripExpensesSummaryDisplay } from "@/Domain/TripExpensesSummaryDisplay";
import type { TripVisitDisplay } from "@/Domain/TripVisitDisplay";
import { defineStore } from "pinia";

export const useTripLogStore = defineStore("tripLog", {
  state: () => {
    return {
      tripVisits: null as TripVisitDisplay[] | null,
      mileageRate: 0,
      expenseSummary: null as TripExpensesSummaryDisplay | null,
    };
  },
  getters: {
    mileageAmount(state) {
      return Number(
        (
          state.expenseSummary?.MileageReimbursed ||
          (state.expenseSummary?.Miles ?? 0) * state.mileageRate
        ).toFixed(2)
      );
    },
    totalBalance(state): string {
      const amounts = [
        this.mileageAmount,
        state.expenseSummary?.Airfare,
        state.expenseSummary?.CarRental,
        state.expenseSummary?.Gas,
        state.expenseSummary?.Tolls,
        state.expenseSummary?.Parking,
        state.expenseSummary?.Taxi,
        state.expenseSummary?.Motel,
        state.expenseSummary?.Food,
        state.expenseSummary?.Misc,
      ];

      return (amounts as number[])
        .reduce((acc, curr) => acc + (curr || 0), 0)
        .toFixed(2);
    },
    totalCorporateCharges(state) {
      const charges = [
        state.expenseSummary?.OuAir,
        state.expenseSummary?.OuCarRental,
        state.expenseSummary?.OuOther,
      ];

      return (charges as number[])
        .reduce((acc, curr) => acc + (curr || 0), 0)
        .toFixed(2);
    },
    totalExpenses() {
      return (
        Number(this.totalBalance) + Number(this.totalCorporateCharges)
      ).toFixed(2);
    },
  },
});
